import React, { useContext } from "react";
import { AuthContext } from '../../contexts/AuthContext'
import { Col, Row, Button } from "reactstrap";
import Footer from "../../layout/Footer/Footer";
import Header from "../../layout/Header/Header";

function BotonesCompras() {
  const { user } = useContext(AuthContext);
  return (
    <>
          <Header />
          {user.menu_ventas ?(
      <div className="container">
        <br />
        <br />
        <Row >
        {/* <Col md={4} align="center">
              {user.grupos ? (
                <Button
                  href="/DepartamentosClientes"
                  className="botonesMenu"
                  color="success"
                >
                  <i class="fas fa-store fa-7x"></i>
                  <br />
                  <br />
                  Departamentos
                </Button>
              ) : (
                <Button disabled className="botonesMenu" color="success">
                  <i class="fas fa-store fa-7x"></i>
                  <br />
                  <br />
                  Departamentos
                </Button>
              )}
            </Col>
        <Col md={4} align="center">
              {user.grupos ? (
                <Button
                  href="/Grupos"
                  className="botonesMenu"
                  color="success"
                >
                  <i class="fas fa-users fa-7x"></i>
                  <br />
                  <br />
                  Grupos
                </Button>
              ) : (
                <Button disabled className="botonesMenu" color="success">
                  <i class="fas fa-users fa-7x"></i>
                  <br />
                  <br />
                  Grupos
                </Button>
              )}
            </Col> */}
        <Col md={4} align="center">
              {user.menu_clientes ? (
                <Button
                  href="/Clientes"
                  className="botonesMenu"
                  color="success"
                >
                  <i class="fas fa-user-tie fa-7x"></i>
                  <br />
                  <br />
                  Clientes
                </Button>
              ) : (
                <Button disabled className="botonesMenu" color="success">
                  <i class="fas fa-user-tie fa-7x"></i>
                  <br />
                  <br />
                  Clientes
                </Button>
              )}
            </Col>
            </Row>
          <br />
          <Row>
        <Col md={4} align="center">
          {user.menu_pedidos ?(
            <Button href="/ListadoPedidos" className="botonesMenu" color="success">
              <i class="fas fa-shopping-basket fa-7x"></i>
              <br />
              <br />
              Pedidos
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-shopping-basket fa-7x"></i>
          <br />
          <br />
          Pedidos
        </Button> }
          </Col>

      

          <Col md={4} align="center">
          {user.surtidos_create ?(
            <Button href="/ListadoPendienteSurtir" className="botonesMenu" color="success">
              <i class="fas fa-truck-moving fa-7x"></i>
              <br />
              <br />
              Surtir
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-truck-moving fa-7x"></i>
          <br />
          <br />
          Surtir
        </Button> }
          </Col>
          
          <Col md={4} align="center">
          {user.menu_surtidos ?(
            <Button href="/ListadoVentas" className="botonesMenu" color="success">
              <i class="fas fa-file-invoice-dollar fa-7x"></i>
              <br />
              <br />
              Notas
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-file-invoice-dollar fa-7x"></i>
          <br />
          <br />
          Notas
        </Button> }
          </Col>
          </Row>
          <br />
          <Row>
          <Col md={4} align="center">
          {user.menu_devoluciones ?(
            <Button href="/ListadoDevoluciones" className="botonesMenu" color="success">
              <i class="fas fa-undo-alt fa-7x"></i>
              <br />
              <br />
              Devoluciones
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-undo-alt fa-7x"></i>
          <br />
          <br />
          Devoluciones
        </Button> }
          </Col>

        
        <Col md={4} align="center">
          {user.menu_ventas ?(
            <Button href="/AnalisisArticulosPedidos" className="botonesMenu" color="success">
              <i class="fas fa-search fa-7x"></i>
              <br />
              <br />
              Analisis Pedidos
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-search fa-7x"></i>
          <br />
          <br />
          Analisis Pedidos
        </Button> }
          </Col>
          {/* <Col md={4} align="center">
          {user.menu_pedidos ?(
            <Button href="/ListadoPedidosCliente" className="botonesMenu" color="success">
              <i class="fas fa-shopping-basket fa-7x"></i>
              <br />
              <br />
              Pedidos <br /> Cliente
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-shopping-basket fa-7x"></i>
          <br />
          <br />
          Pedidos <br /> Cliente
        </Button> }
          </Col> */}

        <Col md={4} align="center">
            {user.menu_ventas ?(
              <Button
                href="/ReporteUltimoPrecio"
                className="botonesMenu"
                color="success"
              >
                <i class="fas fa-dollar-sign fa-7x"></i>
                <br />
                <br />
                Ultimo Precio Cliente
              </Button>
            ): <Button
            disabled
            className="botonesMenu"
            color="success"
          >
            <i class="fas fa-dollar-sign fa-7x"></i>
            <br />
            <br />
            Ultimo Precio Cliente
          </Button> }
            </Col>

            </Row>
        <br />
        <Row>
            <Col md={4} align="center">
            {user.menu_ventas ?(
              <Button
                href="/ReporteUltimoPrecioArticulo"
                className="botonesMenu"
                color="success"
              >
                <i class="fas fa-tshirt fa-7x"></i>
                <br />
                <br />
                Ultimo Precio Articulo
              </Button>
            ): <Button
            disabled
            className="botonesMenu"
            color="success"
          >
            <i class="fas fa-tshirt fa-7x"></i>
            <br />
            <br />
            Ultimo Precio Articulo
          </Button> }
            </Col>
            <Col md={4} align="center">
          {user.menu_ventas ?(
            <Button href="/VentaDirectaCreate" className="botonesMenu" color="success">
              <i class="fas fa-file-invoice-dollar fa-7x"></i>
              <br />
              <br />
              Venta Directa
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-file-invoice-dollar fa-7x"></i>
          <br />
          <br />
          Venta Directa
        </Button> }
          </Col>
          <Col md={4} align="center">
          {user.notasCargo ?(
            <Button href="/ListadoNotasCargo" className="botonesMenu" color="success">
              <i class="fas fa-money-check-alt fa-7x"></i>
              <br />
              <br />
              Notas de Cargo
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-money-check-alt fa-7x"></i>
          <br />
          <br />
          Notas de Cargo
        </Button> }
          </Col>
        </Row>
        <br />
        <Row>
        <Col md={4} align="center">
          {user.menu_surtidos ?(
            <Button href="/ReporteSurtidos" className="botonesMenu" color="success">
              <i class="fas fa-money-check-alt fa-7x"></i>
              <br />
              <br />
              Reporte Surtidos
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-money-check-alt fa-7x"></i>
          <br />
          <br />
          Reporte Surtidos
        </Button> }
          </Col>

          <Col md={4} align="center">
          {user.menu_surtidos ?(
            <Button href="/ListoSurtir" className="botonesMenu" color="success">
              <i class="fas fa-dolly fa-7x"></i>
              <br />
              <br />
              Listo Surtir
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-dolly fa-7x"></i>
          <br />
          <br />
          Listo Surtir
        </Button> }
          </Col>

          <Col md={4} align="center">
          {user.menu_surtidos ?(
            <Button href="/ListoSurtirCliente" className="botonesMenu" color="success">
              <i class="fas fa-dolly fa-7x"></i>
              <br />
              <br />
              Listo Surtir <br /> Clientes
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-dolly fa-7x"></i>
          <br />
          <br />
          Listo Surtir <br /> Clientes
        </Button> }
          </Col>
        </Row>
        <br />
        <Row>
        <Col md={4} align="center">
          {user.menu_surtidos ?(
            <Button href="/AnalisisArticulosPedidosExpo" className="botonesMenu" color="success">
              <i class="fas fa-dolly fa-7x"></i>
              <br />
              <br />
              Analisis <br /> Articulos Pedidos 
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-dolly fa-7x"></i>
          <br />
          <br />
          Analisis <br /> Articulos Pedidos 
        </Button> }
          </Col>
          <Col md={4} align="center">
          {user.menu_surtidos ?(
            <Button href="/AnalisisArticulosPedidosGlobal" className="botonesMenu" color="success">
              <i class="fas fa-dolly fa-7x"></i>
              <br />
              <br />
              Analisis Articulos <br /> Pedidos Global 
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-dolly fa-7x"></i>
          <br />
          <br />
          Analisis Articulos <br /> Pedidos Global 
        </Button> }
          </Col>
          <Col md={4} align="center">
          {user.menu_surtidos ?(
            <Button href="/ReportePrecios" className="botonesMenu" color="success">
              <i class="fas fa-dollar-sign fa-7x"></i>
              <br />
              <br />
              Reporte Precios
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-dollar-sign fa-7x"></i>
          <br />
          <br />
          Reporte Precios
        </Button> }
          </Col>
          
          </Row>
          <Row>
            <Col md={4} align="center">
          {user.edoCtaClientes && user.vendedor == "Si" ?(
            <Button href="/EstadoCuenta" className="botonesMenu" color="success">
              <i class="fas fa-file-invoice-dollar fa-7x"></i>
              <br />
              <br />
             Estado Cuenta
            </Button>
          ): undefined}
          </Col>
          </Row>
      </div>
      ): undefined } 
      
    </>
  );
}

export default BotonesCompras;
